import { Link, Stack } from 'expo-router';
import React, { useCallback, useRef, useState } from 'react';
import { StyleSheet, useWindowDimensions } from 'react-native';
import { View } from '@/components/Themed';
//import YoutubePlayer from "react-native-youtube-iframe";
import { Video, IVideo } from '@/components/Video';
import {
  Button,
} from 'react95-native-rabbl';
import { CustomText, CustomTextStyles } from '@/components/CustomText';
import Head from 'expo-router/head';
import * as AppUtils from '@/utilities/AppUtils';
import * as AppUtilities from '@/utilities/AppUtilities';
import * as AppConstants from '@/utilities/AppConstants';
import * as AppConsts from '@/utilities/AppConsts';
import { useFocusEffect, useRouter } from 'expo-router';
import { Meta } from '@/components/Meta';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
    backgroundColor: 'transparent',
    gap: 20,
  },
});

export default function NotFoundScreen() {
  const video = useRef<IVideo>(null);

  useFocusEffect(
    useCallback(() => {
      return () => {
        video.current?.pause();
      };
    }, [])
  );

  return (
    <>
      <Stack.Screen
        options={{
          title: 'Not Found',

          headerTitleStyle: CustomTextStyles.headerTitle,

          // Remove horizontal bottom line for header
          headerShadowVisible: false,
        }}
      />
      <View style={styles.container}>
        <Meta title={"Not found"} />
        <CustomText>This page doesn't exist.</CustomText>

        <Video
          source={"/videos/5wI1gOKm70k.mp4"}
          width={AppConsts.DEFAULT_VIDEO_WIDTH}
          height={127}
          ref={video}
        />
        {/*
        <YoutubePlayer
          width={Math.min(480, Math.floor(width * 0.75))}
          height={Math.min(270, Math.floor(height * 0.75))}
          videoId={"5wI1gOKm70k"}
          // https://github.com/LonelyCpp/react-native-youtube-iframe/issues/210#issuecomment-988096295
          //webViewProps={{
          //  injectedJavaScript: `
          //    var element = document.getElementsByClassName('container')[0];
          //    element.style.position = 'unset';
          //    element.style.padding = 0;
          //    element.style.margin = 0;
          //    true;
          //  `,
          //}}
          // https://github.com/LonelyCpp/react-native-youtube-iframe/issues/337#issuecomment-2145174181
          baseUrlOverride={AppUtilities.getActualHostLink(false, false) + '/youtubeplayer/iframe.html'}
        />
        */}

        <Link href="/" asChild={true} className={"nontext"}>
          <Button>Go home</Button>
        </Link>
      </View>
    </>
  );
}
